import React, { useState, useEffect } from "react";
import axios from "axios";
import Logo from "../assets/logo-no-background.png";

const LandingPage = () => {
  const [results, setResults] = useState([]);
  const [currentNumber, setCurrentNumber] = useState(null);
  const [nextTime, setNextTime] = useState("");
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  ); // Today's date
  const [nowTime, setNowTime] = useState(new Date().toLocaleTimeString());
  const [timeLeft, setTimeLeft] = useState(""); // Timer state for next draw
  const [isBettingClosed, setIsBettingClosed] = useState(false); // State to track if betting is closed
  const [latestPastResult, setLatestPastResult] = useState(null);

  useEffect(() => {
    fetchResults(selectedDate);
    const interval = setInterval(() => {
      setNowTime(new Date().toLocaleTimeString());
      updateTimer(); // Update countdown every second
    }, 1000);

    return () => clearInterval(interval);
  }, [selectedDate]);

  const fetchResults = async (date) => {
    try {
      const response = await axios.get(`https://backend-1-azed.onrender.com/getResults/${date}`);
      setResults(response.data.results);
      setCurrentNumber(response.data.results[0]?.result || null);
      setNextTime(response.data.nextTime);
  
      const now = new Date();
      const currentMinutes = now.getHours() * 60 + now.getMinutes();
      
      // Convert all result times to minutes
      const parsedResults = response.data.results.map(result => {
        let [time, period] = result.time.split(/(am|pm)/i);
        let [hours, minutes] = time.split(":").map(Number);
        
        // Convert hours to 24-hour format based on "AM/PM" period
        if (period?.toLowerCase() === "pm" && hours !== 12) hours += 12;
        if (period?.toLowerCase() === "am" && hours === 12) hours = 0;
  
        const resultMinutes = hours * 60 + minutes;
        return { ...result, resultMinutes };
      });
  
      // Filter and sort past results
      const pastResults = parsedResults.filter(result => result.resultMinutes <= currentMinutes);
      const sortedResults = pastResults.sort((a, b) => b.resultMinutes - a.resultMinutes);
  
      setLatestPastResult(sortedResults[0] || null);
      setCurrentNumber(sortedResults[0]?.result || null);
    } catch (error) {
      console.error('Error fetching results', error);
    }
  };
  

//   console.log("latest",latestPastResult)
  
  
  
  
  
  

  // Function to get next draw time slot
  const getNextTimeSlot = () => {
    const now = new Date();
    const minutes = now.getMinutes();
    const nextMinutes = Math.ceil(minutes / 15) * 15;

    if (nextMinutes === 60) {
      now.setHours(now.getHours() + 1);
      now.setMinutes(0);
    } else {
      now.setMinutes(nextMinutes);
    }

    const hour = now.getHours();
    const formattedHour = hour % 12 || 12;
    const formattedMinutes = now.getMinutes().toString().padStart(2, "0");
    const period = hour >= 12 ? "pm" : "am";

    return `${formattedHour}:${formattedMinutes}${period}`;
  };

  // Function to calculate the time left until the next draw (in mm:ss format)
  // Function to calculate the time left until the next draw (in mm:ss format)
  const updateTimer = () => {
    const now = new Date();
    const hours = now.getHours();

    // Close betting after 5 PM and before 10 AM
    if (hours >= 17 || hours < 10) {
      setIsBettingClosed(true);
      setTimeLeft(""); // Clear timer since betting is closed
      setNextTime(null); // Clear the next draw time since betting is closed
    } else {
      setIsBettingClosed(false); // Betting is open, calculate time left for the next draw
      const nextDraw = new Date();
      const minutes = now.getMinutes();
      const nextMinutes = Math.ceil(minutes / 15) * 15;

      if (nextMinutes === 60) {
        nextDraw.setHours(now.getHours() + 1);
        nextDraw.setMinutes(0);
      } else {
        nextDraw.setMinutes(nextMinutes);
      }
      nextDraw.setSeconds(0);

      const timeDiff = nextDraw - now; // Difference in milliseconds

      if (timeDiff >= 0) {
        const minutesLeft = Math.floor(timeDiff / 60000); // Convert to minutes
        const secondsLeft = Math.floor((timeDiff % 60000) / 1000); // Remaining seconds
        setTimeLeft(
          `${minutesLeft}:${secondsLeft.toString().padStart(2, "0")}`
        );
      }
    }
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value); // Update selected date
  };

  // Filter the results to show only those that have passed the current time
  const filterResultsByTime = () => {
    const now = new Date(); // Current date and time
  
    return results.filter((result) => {
      let [time, period] = result.time.toLowerCase().split(/(am|pm)/);
      period = period ? period.trim() : ''; // Extract AM/PM
      let [hours, minutes] = time.split(':').map(Number);
  
      // Convert hours to 24-hour format
      if (period === 'pm' && hours !== 12) {
        hours += 12;
      } else if (period === 'am' && hours === 12) {
        hours = 0;
      }
  
      // Ensure selectedDate is in the format "YYYY-MM-DD"
    //   console.log('Selected Date:', selectedDate);
    //   console.log('Result Time:', result.time);
  
      // Construct date string for parsing
      const dateStr = `${selectedDate}T${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
      const resultDateTime = new Date(dateStr);
  
    //   console.log('Constructed Date String:', dateStr);
    //   console.log('Parsed Result Time:', resultDateTime); // Check parsed Date object
  
      // Check if parsed Date is valid
      if (isNaN(resultDateTime.getTime())) {
        // console.error('Invalid Date:', resultDateTime);
      } else {
        // console.log('Valid Date:', resultDateTime);
      }
  
      // Return if the date-time is before the current date-time
      return resultDateTime <= now;
    });
  };
  
  
  


  return (
    <div className="bg-gray-900 min-h-screen flex flex-col items-center p-6">
      {/* Header */}
      <div className="flex justify-between items-center w-full max-w-lg mb-6">
        <div className="flex items-center">
          <img src={Logo} alt="502 Gold Logo" className="w-12 mr-4" />
        </div>
        <button className="text-white text-xl p-2 rounded-md hover:bg-gray-700 transition">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>

      {/* Game & Date Picker */}
      <div className="bg-gray-800 p-6 rounded-lg shadow-lg max-w-lg w-full mb-8">
        <div className="flex flex-col space-y-4">
          <div className="flex flex-col">
            <label className="text-white font-semibold mb-1">
              Selected Date
            </label>
            <input
              type="date"
              value={selectedDate}
              onChange={handleDateChange}
              max={new Date().toISOString().split("T")[0]}
              className="p-2 bg-gray-700 text-white rounded-md focus:outline-none"
            />
          </div>
        </div>
      </div>

      {/* Current Result */}
   
     


      {/* Info Section */}
      <div className="bg-gray-700 text-white p-4 rounded-lg shadow-lg flex justify-between w-full max-w-lg mb-8">
        <div className="border-r w-36">
        <p className="">
          Next Draw: 
        </p>
        <p>
        {isBettingClosed ? "--" : getNextTimeSlot()}
        </p>
        </div>
        {/* Don't show next draw if betting is closed */}
        <div className="border-r ml-2 w-36">
          <p>Date:</p>
          <p className=""> {selectedDate}</p>
        </div>
        <p className="ml-2">Current Time: {nowTime}</p>
      </div>

      {/* Countdown Timer or Betting Closed Message */}
      <div className="bg-red-600 text-white text-center p-4 rounded-lg shadow-lg mb-6 w-full max-w-lg">
  {isBettingClosed ? (
    <p className="text-2xl font-extrabold">
      Betting is closed for today, try your luck tomorrow from 10 AM
    </p>
  ) : (
    <>
      <p className="text-xl font-bold">Time Left for Next Draw:</p>
      <p className="text-3xl font-extrabold">{timeLeft}</p>
    </>
  )}

  {/* Latest Result Time and Number */}
  {latestPastResult ? (
    <div className="mt-4 flex justify-around border-t">
      {/* <p className="text-lg font-semibold">Latest Result:</p> */}
      <p className="text-2xl mt-4">
        {latestPastResult.time} 
      </p>
      <p className="text-2xl mt-4"> {latestPastResult.result === 0 ? "00" : latestPastResult.result}</p>
    </div>
  ) : (
    <p className="mt-4 text-lg">No results available yet</p>
  )}
</div>


      {/* Results Table */}
      <div className="bg-gray-800 text-white p-6 rounded-lg shadow-lg w-full max-w-lg">
        <div className="grid grid-cols-2 gap-4 text-center font-semibold text-yellow-400 mb-4">
          <p>Time</p>
          <p>Number</p>
        </div>
        <div className="grid grid-cols-2 gap-4 text-center">
        {filterResultsByTime().length > 0 ? (
            filterResultsByTime().map((result, index) => (
              <React.Fragment key={index}>
                <p>{result.time}</p>
                <p>{result.result === 0 ? "00" : result.result}</p>
              </React.Fragment>
            ))
          ) : (
            <p className="col-span-2 text-center">No results available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
